import { useMainStore } from "@/stores/mainStore";
import { listModule, phase } from "@/types/global";
import { useTranslation } from "i18next-vue";
import { computed, ComputedRef, onMounted, Ref, ref, toRaw } from "vue";
import axios from "axios";

export function useModules(
  slots: Ref<{} | undefined>,
  allowedEdit: boolean,
  current_status: Ref<String | undefined>,
  licenceId: Ref<number | undefined>,
  paymentMode: Ref<string | undefined>,
  current_phase: Ref<phase | undefined>,
  next_phase: Ref<phase | undefined>,
  current_phase_mode: string = "monthly",
  next_billing_cycle_anchor: number | null
) {
  const { t } = useTranslation();
  const mainStore = useMainStore();
  // const status_by_module = computed(() => {
  //   const result = {};
  //   for (const [type, modules] of Object.entries(current_status.value)) {
  //     for (const m of modules as string[]) {
  //       result[m] = type;
  //     }
  //   }
  // });
  //
  const someoneLeft = ref(false);

  onMounted(() => {
    console.log("useModules next_phase", next_phase.value);

    for (const module of mainStore.modules) {
      if (module.disabled) continue;
      if (allowedEdit && module.value === 1 << 5) continue;
      console.log("Im here,", next_phase.value[module.value]);

      if (next_phase.value[module.value] !== slots.value[module.value]) {
        someoneLeft.value = true;
      }

      const element: listModule = Object.assign({}, module, {
        slots:
          current_status.value !== null ? next_phase.value[module.value] : 0,
        monthEnd: Math.max(
          0,
          current_phase.value[module.value] - next_phase.value[module.value]
        )
      });

      if (slots.value[module.value] === undefined) {
        return [];
      }

      initialItems.value.push(element);
    }
  });

  const headers: any = computed(() => {
    return [
      {
        title: t("views.licence.table.module"),
        align: "start",
        sortable: false,
        key: "module",
        value: (item) => t("views.licence.modules." + item.name + ".name"),
        width: "25%"
      },
      {
        title: t("views.licence.table.description"),
        align: "start",
        sortable: false,
        key: "description",
        value: (item) =>
          t("views.licence.modules." + item.name + ".description"),
        width: "25%"
      },
      {
        title: t("views.licence.table.active"),
        key: "active",
        sortable: false,
        width: "25%",
        hidden: !allowedEdit
      },
      {
        title: t("views.licence.table.slots"),
        key: "slots",
        value: (item) => item.slots,
        width: "25%",
        hidden: allowedEdit
      },
      {
        title: t("views.licence.table.price"),
        key: "price",
        sortable: false,
        align: "end",
        value: (item) => {
          console.log(
            item.module,
            item.price,
            Math.floor(item.price) / 100 + " €"
          );
          return (
            Math.floor(
              paymentMode.value === "yearly" ? item.price_yearly : item.price
            ) /
              100 +
            " €"
          );
        },
        width: "25%"
      },
      {
        title: t("views.licence.table.total"),
        key: "priceAll",
        sortable: false,
        align: "end",
        value: (item) => {
          console.log(
            "paymentMode",
            paymentMode.value,
            item.module,
            item.price,
            item.price_yearly,
            Math.floor(item.price) / 100 + " €"
          );
          return (
            Math.floor(
              (paymentMode.value === "yearly"
                ? item.price_yearly
                : item.price) * item.slots
            ) /
              100 +
            " €"
          );
        },
        width: "25%"
      }
    ].filter((i) => !i.hidden);
  });

  const initialItems: Ref<listModule[]> = ref([]);

  const items: ComputedRef<listModule[]> = computed(() => {
    const result = [];
    for (const module of mainStore.modules) {
      if (module.disabled) continue;
      if (allowedEdit && module.value === 1 << 5) continue;

      const element: listModule = Object.assign({}, module, {
        slots: slots.value[module.value],
        monthEnd: Math.max(
          0,
          next_phase.value[module.value] - slots.value[module.value]
        )
        // payment_state: status_by_module.value[module.value]
      });

      result.push(element);
    }

    return result;
  });

  const monthlyToYearly = computed(() => {
    return paymentMode.value === "yearly" && current_phase_mode === "monthly";
  });

  const yearlyToMonthly = computed(() => {
    return paymentMode.value === "monthly" && current_phase_mode === "yearly";
  });

  const oldMonthlyCost = computed(() => {
    return (
      initialItems.value.reduce((acc, module) => {
        acc += module.price * module.slots;
        return acc;
      }, 0) / 100
    );
  });

  const oldYearlyCost = computed(() => {
    return (
      initialItems.value.reduce((acc, module) => {
        acc += module.price_yearly * module.slots;
        return acc;
      }, 0) / 100
    );
  });

  const monthlyCost = computed(() => {
    return (
      items.value.reduce((acc, module) => {
        acc += module.price * module.slots;
        return acc;
      }, 0) / 100
    );
  });

  const yearlyCost = computed(() => {
    return (
      items.value.reduce((acc, module) => {
        acc += module.price_yearly * module.slots;
        return acc;
      }, 0) / 100
    );
  });

  const modulesAdded: ComputedRef<Record<number, number>> = computed(() => {
    console.log("modulesAdded ", toRaw(items.value), toRaw(initialItems.value));
    return Object.fromEntries(
      items.value.map((module, index) => {
        console.log(module, index, toRaw(initialItems.value[index]));
        return [module.value, module.slots - initialItems.value[index].slots];
      })
    );
  });

  const chargeNeeded = computed(() => {
    if (!next_billing_cycle_anchor) {
      return false;
    }

    if (monthlyToYearly.value && !Object.values(modulesRemoved.value).filter((item) => item > 0).length) {
      return true;
    }
    return Object.entries(modulesAdded.value).reduce((acc, [name, i]) => {
      return i > 0 && next_phase.value[Number(name)] < slots.value[Number(name)]
        ? acc + i
        : acc;
    }, 0);
  });

  const changeNeeded = computed(() => {
    if (next_billing_cycle_anchor && (monthlyToYearly.value || yearlyToMonthly.value)) {
      return true;
    }
    return initialItems.value.reduce((result, initItem, index) => {
      return result || initItem.slots !== items.value[index].slots;
    }, false);
  });

  const modulesRemoved = computed(() => {
    return Object.fromEntries(
      initialItems.value.map((module, index) => [
        module.name,
        module.slots - items.value[index].slots
      ])
    );
  });

  function loadPreview() {
    additionalPrice.value = null;
    const byName = Object.fromEntries(
      mainStore.modules.map((module) => [
        module.name,
        slots.value[module.value]
      ])
    );

    axios
      .post(
        current_status.value !== null
          ? `/api/stripe/preview-sub-update/${licenceId.value}`
          : "/api/stripe/preview-sub-create",
        {
          byName,
          paymentMode: paymentMode.value,
          current_phase_elements: current_phase.value,
          current_phase_mode: current_phase_mode
        }
      )
      .then((response) => {
        console.log("Success", response.data);
        additionalPrice.value =
          response.data.amount_due / 100 +
          " " +
          t("units." + response.data.currency);
      });
  }

  const additionalPrice = ref<null | string>(null);

  //   const remainingDaysMonth = computed(() => {
  //     const now = new Date();
  //     const monthDays = new Date(
  //       now.getFullYear(),
  //       now.getMonth() + 1,
  //       0
  //     ).getDate();
  //     const remainingDays = monthDays - now.getDate() + 1;
  //     return remainingDays;
  //   });
  //
  //   const remainingDaysYear = computed(() => {
  //     const now = new Date();
  //     const yearDays = new Date(now.getFullYear() + 1, 0, 1).getTime();
  //     const remainingDays =
  //       Math.round((yearDays - now.getTime()) / (1000 * 60 * 60 * 24)) + 1;
  //     return remainingDays;
  //   });

  const remainingDays = computed(() => {
    const now = new Date().getTime() / 1000;
    if (!next_billing_cycle_anchor) {
      return 0;
    }
    return Math.round((next_billing_cycle_anchor - now) / (60 * 60 * 24)) + 1;
  });

  const reviewData = computed(() => {
    return {
      remainingDays: remainingDays.value,
      oldCosts:
        paymentMode.value === "yearly"
          ? oldYearlyCost.value
          : oldMonthlyCost.value,
      newCosts:
        paymentMode.value === "yearly" ? yearlyCost.value : monthlyCost.value,
      additionalPrice: additionalPrice.value,
      yearly: paymentMode.value === "yearly",
      date: next_billing_cycle_anchor,
      switchYearly: monthlyToYearly.value,
      switchMonthly: yearlyToMonthly.value
    };
  });

  return {
    headers,
    initialItems,
    items,
    oldMonthlyCost,
    oldYearlyCost,
    monthlyCost,
    yearlyCost,
    modulesRemoved,
    additionalPrice,
    loadPreview,
    chargeNeeded,
    changeNeeded,
    someoneLeft,
    reviewData
  };
}
